<template>
  <div class="w-100">
    <MazPhoneNumberInput
      v-if="countryCode"
      :id="id"
      v-model="localValue"
      :placeholder="placeholder"
      :countryCode="countryCode"
      :locale="locale"
      :translations="currentTranslations"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput';

export default {
  components: { MazPhoneNumberInput },
  inject: ['locale'],
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const countryCode = ref('');

    const countryMap = {
      'es-419': 'MX', // Latinoamérica y el Caribe -> México
      'es-AR': 'AR', // Español de Argentina
      'es-CO': 'CO', // Español de Colombia
      'es-MX': 'MX', // Español de México
      'es-US': 'US', // Español en EE. UU.
      'en-US': 'US', // Inglés de Estados Unidos
      'en-GB': 'GB', // Inglés de Gran Bretaña
      'fr-FR': 'FR', // Francés de Francia
    };

    const detectCountryCode = () => {
      const language = navigator.language || navigator.userLanguage;
      const country = countryMap[language] || 'US';
      return country;
    };

    onMounted(() => {
      countryCode.value = detectCountryCode();
    });

    const localValue = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    return { localValue, countryCode };
  },

  data() {
    return {
      componentTranslations: {
        en: { // English Translations
          countrySelector: {
            placeholder: 'Country code',
            error: 'Choose country',
            searchPlaceholder: 'Search a country',
          },
          phoneInput: {
            placeholder: 'Phone number',
            example: 'Example:',
          },
        },
        es: { // Spanish Translations
          countrySelector: {
            placeholder: 'Código de país', // Providing a Spanish placeholder instead of empty
            error: 'Elige un país',
            searchPlaceholder: 'Buscar un país',
          },
          phoneInput: {
            placeholder: 'Número de teléfono',
            example: 'Ejemplo:',
          },
        }
      }
    }
  },
  computed: {
    // Computed property to easily get the translations for the current locale
    currentTranslations() {
      // Return translations for the current locale, fallback to English if locale is unknown
      return this.componentTranslations[this.locale] || this.componentTranslations.en;
    }
  }
};
</script>

<style lang="scss">
.m-phone-number-input,
.m-input-wrapper-input,
.m-input-wrapper,
.m-input-input {
  width: 100%;
  color: #212529;
  background-color: #fff;
}
</style>